function toggleFreeResource(elementNumber) {

	const iconElement = document.getElementById('js--free-resource-header-icon-' + elementNumber);
	
	// Check if element is already opened
	let update = true;
	if (iconElement.classList.contains('type-open')) {
		update = false
	}
	
	// Close all content
	const freeResourcesContents = document.getElementsByClassName('js--free-resource-content-collapse');
	if (freeResourcesContents.length !== 0) {
		Array.from(freeResourcesContents).forEach(
			function (element, index, array) {
				element.style.display = 'none';
			}
		);
	}
	
	// Change close icon
	const freeResourcesToggleIcons = document.getElementsByClassName('js--all-icon-close');
	if (freeResourcesToggleIcons.length !== 0) {
		Array.from(freeResourcesToggleIcons).forEach(
			function (element, index, array) {
				if (element.classList.contains('type-open')) {
					element.classList.remove('type-open');
					element.classList.add('type-close');
				}
			}
		);
	}
	
	// Open element if was not opened before
	if (iconElement.classList.contains('type-close') && update) {
		iconElement.classList.remove('type-close');
		iconElement.classList.add('type-open');
		
		const content = document.getElementById('js--free-resource-content-' + elementNumber);
		content.style.display = 'flex';
	}
}